const formaterDemandeArmeTrouvee = (dataForm) => {
    return {
        lieuDecouverte: dataForm.lieuDecouverte,
        departementDecouverte: dataForm.departementDecouverte,
        dateDecouverte: dataForm.dateDecouverte,
        numeroRga: dataForm.numeroRga,
        numeroCarcasse: !dataForm.hasNumeroSerie ? dataForm.numeroCarcasse : null,
        armeIsNeutralisee: dataForm.armeIsNeutralisee,
    };
};

export default formaterDemandeArmeTrouvee;
